import type { FaireProductEntity } from "../../entity_types/product";

export const p_4sryce635n: FaireProductEntity = {
  token: "p_4sryce635n",
  type: "product",
  name: "Solid XL Shea Butter Conditioner Bar (Natural Fragrances)",
  brandToken: "b_3yerfaqmmt",
  brandName: "Desesh",
  imageUrl:
    "https://cdn.faire.com/fastly/79c5629ad90be03b91cae416333273ea2bf92fc1389624ca0c9bff68a134e678.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5be4b942267fc35d24215771ec3795d9962170ab35bea757edc8fe55c094219.jpeg",
    "https://cdn.faire.com/fastly/8db91d3c46b94897764ee003130bbf2721b21d2fd4386ddd043b1537eeaa0336.jpeg",
    "https://cdn.faire.com/fastly/ee6b3e3d34a466c0660d781b04af74eaffd1638c8a2db7103b81424e2826faac.png",
    "https://cdn.faire.com/fastly/d2cbfdf9e8ee43d6214708237af124262956a5e25260d70f0c96796a6d7b2e5d.jpeg",
    "https://cdn.faire.com/fastly/a4654e5516c9acf053d75d184da3937d5beaf3d6a159a25e0dd617cfdbd6876b.jpeg",
    "https://cdn.faire.com/fastly/16b3cef3dcffbfc20fb9a3425b752ae99af443fa1470129345a1941cca31668d.jpeg",
    "https://cdn.faire.com/fastly/19c058c345f52b5350e96359c4143f2f8e9e1fbfd9990344b4919476ecea1d26.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "50% larger than our Argan Oil bar allowing you to enjoy a premium salon-quality conditioner experience without the plastic bottle or harsh ingredients. Crafted in small batches in the USA, this concentrated solid bar is designed to replace 2-3 12oz bottles and is full of hydrating oils and nutrients. Use along with the shampoo bar to make your hair feel healthier, lighter, and bring back your natural shine. Made for all hair types. What's different? Premium quality ingredients, plastic free, phthalate free, paraben free, palm oil free, SLS free, vegan and cruelty free, no artificial fragrances or dyes, low waste plastic free cardboard packaging, and made in small batches in the United States.",
  tags: [],
  msrpDollars: 24.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:09.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
